const outfitsWithColor = ['NURSE_OUTFIT_1'];

function outfitHasColor(outfitKey) {
  return outfitsWithColor.includes(outfitKey);
}

module.exports = { outfitHasColor, outfitsWithColor };